import { useEffect, useState } from "react";
import { _CreditAccount } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";

interface Props {
    beanRequestCredit: any;
}
export const Amortizacion = ({ beanRequestCredit }: Props) => {

    const instance = useDataBean(_CreditAccount);
    const { lista, setLista, bean, setBean } = instance;

    useEffect(() => {
        instance.instance.generateAmotizationTable(beanRequestCredit.AmountCredit + "", beanRequestCredit.AmountTax + "", beanRequestCredit.Cuotes).then(
            (resp: any) => {
                console.log(resp);
                if (resp) {
                    let temp: any = [];
                    resp.forEach(element => {
                        temp.push(
                            {
                                DataBeanProperties: element
                            }
                        )
                    });
                    setLista(temp)
                }
            }
        )
    }, [beanRequestCredit.AmountCredit, beanRequestCredit.AmountTax, beanRequestCredit.Cuotes])

    const head = [
        { title: 'Cuota', property: 'NUMERO_CUOTA', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha', property: 'FECHA_CUOTA', visible: true },
        { title: 'Interes', property: 'VALOR_INTERES_FIJO', visible: true },
        { title: 'Capital', property: 'VALOR_CAPITAL', visible: true, mask: MASK_MONEY },
        { title: 'Cuota', property: 'VALOR_CUOTA', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Capital', property: 'SALDO_CAPITAL', visible: true, mask: MASK_MONEY },

    ]

    return (
        <div className="row">
            <div className="col">
                <BasicTable head={head} body={lista} rowSet={setBean}></BasicTable>
            </div>
        </div>
    )
}